import React from 'react';
import { Calendar } from 'lucide-react';

const DateRangePicker = ({ startDate, endDate, onChange }) => {
  const handleStartDateChange = (e) => {
    const val = e.target.value;
    const newStartDate = val ? new Date(val) : null;
    onChange({ startDate: newStartDate, endDate });
  };

  const handleEndDateChange = (e) => {
    const val = e.target.value;
    const newEndDate = val ? new Date(val) : null;
    onChange({ startDate, endDate: newEndDate });
  };

  const formatDateForInput = (date) => {
    if (!date || isNaN(new Date(date).getTime())) {
      return '';
    }
    try {
      return new Date(date).toISOString().split('T')[0];
    } catch (err) {
      return '';
    }
  };

  return (
    <div className="flex items-center space-x-2">
      <div className="flex items-center space-x-2">
        <Calendar className="h-4 w-4 text-gray-400" />
        <span className="text-sm text-gray-600">Date Range:</span>
      </div>
      
      <input
        type="date"
        value={formatDateForInput(startDate)}
        onChange={handleStartDateChange}
        className="input input-sm w-32"
      />
      
      <span className="text-gray-400">to</span>
      
      <input
        type="date"
        value={formatDateForInput(endDate)}
        onChange={handleEndDateChange}
        className="input input-sm w-32"
      />
    </div>
  );
};

export default DateRangePicker; 